





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxPopup } from 'devextreme-vue/popup';
import Card from '@/components/default/Card.vue';
import Popup from '@/components/default/Popup.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import { DxAutocomplete } from 'devextreme-vue/autocomplete';
import { DxTextBox, DxLookup } from 'devextreme-vue';
import { DxDataGrid, DxColumnFixing, DxEditing, DxColumn, DxRequiredRule, DxStateStoring, DxMasterDetail } from 'devextreme-vue/data-grid';
import _ from 'lodash';
import $ from 'jquery';
import { ArticleType, IArticle, MeasuringState, IMeasuringStateLine, MeasuringStateLine, IMeasuringStateBlock, MeasuringStateBlock } from '@/data/web-api-client';

@Component({
  components: {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxRequiredRule,
    DxStateStoring,
    DxMasterDetail,
    DxLookup,
    DxPopup,
    DxTextBox,
    Card,
    DxColumnFixing,
    DxAutocomplete,
    Popup,
    Datagrid,
  },
})
export default class MeasuringStateBlockCard extends Vue {
  @Prop({ required: true })
  value!: MeasuringStateBlock;

  @Prop({ required: true })
  private projectType!: string;

  @Prop({ required: false, default: false })
  disabled!: boolean;

  rowPrepared(e: any) {
    if (e.rowType === 'data') {
      if (e.data.completed) {
        $(e.rowElement).addClass('bg-success text-light');
      }

      if (!e.data.visibleInList) {
        e.rowElement.style.display = 'none';
      }
    }
  }

  onEditorPreparing(e: any) {
    if (e.dataField !== 'selected') {
      return;
    }

    if (e.parentType == 'dataRow' && !e.row.data.executionCanBeCanceled) {
      e.editorOptions.disabled = true;
    }
  }

  get articles(): IArticle[] {
    return this.$store.getters['articles/items'];
  }

  get toolbarOptions() {
    const self = this;

    return [
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          text: 'Alles selecteren',
          stylingMode: 'outlined',
          type: 'default',
          onClick: (e: any) => {
            self.value
              .lines!.filter((line) => line.visibleInList)
              .forEach((line) => {
                line.selected = true;
              });
          },
          disabled: this.disabled,
        },
      },
    ];
  }

  get columns() {
    const self = this;

    return [
      {
        dataField: 'selected',
        caption: '',
        dataType: 'boolean',
      },
      {
        caption: 'Facturatie status',
        type: 'buttons',
        name: 'invoice status',
        buttons: [
          {
            hint: 'Gefactureerd',
            icon: 'fas fa-euro-sign',
            visible(e: any) {
              return e.row.data.invoiced == true;
            },
          },
          {
            hint: 'Afgerekend aan onderaannemer',
            icon: 'fas fa-hard-hat',
            visible(e: any) {
              return e.row.data.invoicedSubcontractor == true;
            },
          },
          {
            hint: 'Aanwezig op vorderstaat',
            icon: 'fas fa-ruler-combined',
            visible(e: any) {
              return e.row.data.includedInProgressState == true;
            },
          },
        ],
      },
      {
        dataField: 'description',
        caption: 'Beschrijving',
      },
      {
        dataField: 'length',
        caption: 'Lengte',
        dataType: 'number',
        alignment: 'left',
      },
      {
        dataField: 'height',
        caption: 'Hoogte',
        dataType: 'number',
        alignment: 'left',
      },
      {
        dataField: 'amount',
        caption: 'Aantal',
        dataType: 'number',
        alignment: 'left',
      },
      {
        dataField: 'quantity',
        caption: 'Totaal',
        dataType: 'number',
        alignment: 'left',
        calculateDisplayValue(value: any) {
          if (value.quantity) {
            return Math.round(value.quantity * 1000) / 1000 + ' ' + value.measuringUnit;
          }
          return 0;
        },
      },
      {
        dataField: 'remarks',
        caption: 'Opmerking',
      },
      {
        dataField: 'monthExecuted',
        caption: 'Maand uitgevoerd',
        dataType: 'date',
        format: 'MMMM yyyy',
      },
      {
        dataField: 'qualityCheckMonth',
        caption: 'Uitvoering gecontroleerd voor',
        dataType: 'date',
        format: 'MMMM yyyy',
      },
      {
        dataField: 'lineId',
        visible: false,
      },
      {
        dataField: 'parentLineId',
        visible: false,
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Kost werk ingeven',
            icon: 'fas fa-exclamation-triangle',
            visible(e: any) {
              return !e.row.data.labourCost && e.row.data.labourCost !== 0 && !self.disabled;
            },
            onClick: (e: any) => {
              let value = prompt('Geef de arbeidskost in', '0');
              if (isNaN(value as any)) {
                value = prompt('Geef de arbeidskost in', '0');
              }

              e.row.data.labourCost = parseInt(value as string, 10);
              self.$emit('updated');
            },
          },
          {
            hint: 'splitsen',
            icon: 'fas fa-random',
            visible(e: any) {
              if (!e.row.data.articleId || e.row.data.articleId === '' || self.disabled) {
                return false;
              }
              const article = self.articles.find((a: any) => a.id === e.row.data.articleId);

              if (article && article.type === ArticleType.Combination) {
                return true;
              }

              return false;
            },
            onClick: (e: any) => {
              const line = e.row.data as IMeasuringStateLine;
              const article = self.articles.find((a: any) => a.id === line.articleId);
              if (!article) {
                alert('kan niet gesplits worden');
                return;
              }
              const bom = article.billOfMaterials;
              if (!bom) {
                return;
              }

              const result: MeasuringStateLine[] = [];

              bom.forEach((bomItem) => {
                const containedArticle = self.articles.find((o) => o.id === bomItem.objectId);
                if (!containedArticle) {
                  alert('kan niet gesplits worden');
                  return;
                }

                result.push(
                  new MeasuringStateLine({
                    id: this.$helper.getGuid(),
                    code: containedArticle.name,
                    articleId: containedArticle.id,
                    articleCategoryId: containedArticle.categoryId,
                    description: `${containedArticle.name}: ${containedArticle.description}`,
                    length: line.length,
                    height: line.height,
                    quantity: line.quantity! * bomItem.amount!,
                    amount: line.amount, // aantal items voorbeeld 2 deuren van 2m op 1m
                    measuringUnit: containedArticle.measuringUnit,
                    labourCost: containedArticle.labourCosts!.find((o) => o.type === this.projectType)!.cost,
                    completed: line.completed,
                    remarks: line.remarks,
                    selected: false,
                    visibleInList: true,
                    executionCanBeCanceled: true,
                    variant: '',
                  })
                );
              });

              const index = this.value.lines!.findIndex((l) => l.id === line.id);
              this.value.lines!.splice(index, 1, ...result);

              self.$emit('updated');
            },
          },
        ],
      },
    ];
  }
}
